import DiagramUI from "./DiagramUI";
export default class AutoRefreshDiagramUI extends DiagramUI {

    componentDidMount() {
        super.componentDidMount();
        this.stopAutoRefresh();
        if (this.props.model.isAutoRefresh === true) {
            this.startAutoRefresh(this.props.model.autoRefreshInterval)
        }
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        this.stopAutoRefresh()
    }
    // componentWillReceiveProps(nextProps) {
    //     let autoRefresh = nextProps.model.isAutoRefresh
    //     let autoRefreshInterval = nextProps.model.autoRefreshInterval
    //     if (this.props.model.isAutoRefresh !== autoRefresh || this.props.model.autoRefreshInterval !== autoRefreshInterval) {
    //         this.stopAutoRefresh();
    //     }
    //     if (autoRefresh === true) {
    //         this.startAutoRefresh(autoRefreshInterval)
    //     }
    // }
    onPropertyValueChanged(name, valOld, valNew, subName) {
        super.onPropertyValueChanged(name, valOld, valNew, subName)
        if (subName === undefined) {
            switch (name) {
                case "isAutoRefresh":
                case "autoRefreshInterval":
                    this.stopAutoRefresh();
                    let autoRefreshInterval = this.props.model.autoRefreshInterval
                    if (this.props.model.isAutoRefresh === true) {
                        this.startAutoRefresh(autoRefreshInterval)
                    }
                    break;
            }
        }
    }
    startAutoRefresh(interval) {
        if (!(typeof interval == "number")) return
        if (interval <= 0) return
        interval *= 1000
        this.interval = setInterval(() => {
            this.needRefresh()
        }, interval)
    }
    needRefresh() {
        this.forceUpdate()
    }
    stopAutoRefresh() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }
}
